
import axios from 'axios'

// Position Service
export const positionService = {
  getPositions,
  getAssetsPositions,
  getStopPositions,
  getLastPositions
}

function getPositions (cancel, url, token, vehicleId, driverId, tsStart, tsEnd) {
  const params = {}
  if (vehicleId) {
    params.vehicle = vehicleId
  }
  if (driverId) {
    params.driver = driverId
  }
  if (driverId) {
    params.driver = driverId
  }
  params.start = tsStart
  params.end = tsEnd
  const requestUrl = url + '/positions'
  const headers = { Authorization: 'Bearer ' + token }
  return getPaginatedPositions(cancel, requestUrl, headers, params, [])
}

function getAssetsPositions (cancel, url, token, imei, tsStart) {
  const params = {}

  params.ts = tsStart
  params.imei = imei
  const requestUrl = url + '/lastscans'
  const headers = { Authorization: 'Bearer ' + token }
  return getPaginatedAssetPositions(cancel, requestUrl, headers, params, [])
}

function getPaginatedAssetPositions (cancel, requestUrl, headers, params, listPositions, nextPage) {
  // var curParams = params;
  // if (nextPage) {
  //   curParams['page'] = nextPage;
  // }
  var requestOptions = {
    headers: headers,
    cancelToken: cancel,
    params: params
  }
  if (nextPage) {
    requestOptions.params.page = nextPage
  }
  return axios.get(requestUrl, requestOptions)
    .then(response => {
      if (response && response.data && response.data.blescans) {
        listPositions = listPositions.concat(response.data.blescans)
        if (response.data.nextPage) {
          return getPaginatedPositions(cancel, requestUrl, headers, params, listPositions, response.data.nextPage)
        }
        return listPositions
      }
      return Promise.reject({ message: 'Invalid response' })
    })
    .catch(error => {
      if (axios.isCancel(error)) {
        // return Promise.reject({message: "Request canceled"});
        return Promise.reject(undefined)
      }
      return Promise.reject(error.message)
    })
}

function getPaginatedPositions (cancel, requestUrl, headers, params, listPositions, nextPage) {
  // var curParams = params;
  // if (nextPage) {
  //   curParams['page'] = nextPage;
  // }
  var requestOptions = {
    headers: headers,
    cancelToken: cancel,
    params: params
  }
  if (nextPage) {
    requestOptions.params.page = nextPage
  }
  return axios.get(requestUrl, requestOptions)
    .then(response => {
      if (response && response.data && response.data.positions) {
        listPositions = listPositions.concat(response.data.positions)
        if (response.data.nextPage) {
          return getPaginatedPositions(cancel, requestUrl, headers, params, listPositions, response.data.nextPage)
        }
        return listPositions
      }
      return Promise.reject({ message: 'Invalid response' })
    })
    .catch(error => {
      if (axios.isCancel(error)) {
        // return Promise.reject({message: "Request canceled"});
        return Promise.reject(undefined)
      }
      return Promise.reject(error.message)
    })
}

function getStopPositions (cancel, url, token, vehicleId, driverId, tsStart, tsEnd) {
  return getEventPositions(cancel, 'stop', url, token, vehicleId, driverId, tsStart, tsEnd)
}

function getLastPositions (cancel, url, token, vehicleId, driverId) {
  return getEventPositions(cancel, 'last', url, token, vehicleId, driverId, undefined, undefined)
}

function getEventPositions (cancel, eventType, url, token, vehicleId, driverId, tsStart, tsEnd) {
  const params = {}
  if (vehicleId) {
    params.vehicle = vehicleId
  }
  if (driverId) {
    params.driver = driverId
  }
  if (eventType != 'last') {
    params.start = tsStart
    params.end = tsEnd
  }

  const requestOptions = {
    headers: { Authorization: 'Bearer ' + token },
    cancelToken: cancel,
    params: params
  }
  const requestUrl = url + '/positions/' + eventType

  return axios.get(requestUrl, requestOptions)
    .then(response => {
      if (response && response.data && response.data.positions) {
        return response.data.positions
      }
      return Promise.reject({ message: 'Invalid response' })
    })
    .catch(error => {
      if (axios.isCancel(error)) {
        // return Promise.reject({message: "Request canceled"});
        return Promise.reject(undefined)
      }
      return Promise.reject(error.message)
    })
}
